import 'bootstrap/dist/css/bootstrap.min.css';

const Navbar = () => (
  <nav className="navbar navbar-expand-lg text-light bg-dark mb-5">
    <div className="container-fluid">
      <h3 className="mx-auto">weather info</h3>
    </div>
  </nav>
);

export default Navbar;
